import React from 'react';
import cn from 'classnames';
import isNil from 'lodash/isNil';
import { getPrice } from 'shared/../helpers/utils';
import { Link } from 'react-router-dom';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const KeyValue = ({
  keyName, value, isCurrency, isLink, to, className, ...props
}) => {
  const containerClassName = cn('key-value-container', { [className]: !!className });
  const isEmptyValue = !isCurrency && (isNil(value) || value === '');
  const emptyValueSign = keyName ? '-' : '';

  const toDisplay = (isEmptyValue ? emptyValueSign : value);

  return (
    <div className={containerClassName} {...props}>
      {keyName && <div className='key-data'>{`${keyName} `}</div>}
      {/* eslint-disable-next-line no-nested-ternary */}
      <div className='value-data'>
        {isCurrency && getPrice(value)}
        {((!isCurrency && !isLink) || isEmptyValue) && toDisplay}
        {(isLink && !isEmptyValue) && (
          <Link className='base-link' to={to} target='_blank'>
            {value}
            <span className='k-icon k-i-hyperlink-open-sm' />
          </Link>
        )}
      </div>
    </div>
  );
};

export default KeyValue;
